import React from 'react';
import style from './container.module.scss';

const Container = ({ children , className }) => (
    <div className={[style.container, className].join(' ')}>{children}</div>
);

export default Container;
